import { Controller } from "@hotwired/stimulus";
import Inputmask from "inputmask";

const defaultConfig = {
  alias: "decimal",
  groupSeparator: " ",
  autoGroup: true,
  radixPoint: ",",
  autoUnmask: true,
  groupSize: 3,
  digits: 2,
  removeMaskOnSubmit: true,
  placeholder: "",
  unmaskAsNumber: true,
  onBeforeMask: (value) => {
    if ([null, undefined].includes(value)) {
      // Fixes this error in the inputmask library for null values : https://github.com/RobinHerbots/Inputmask/issues/1485#issuecomment-805743647
      // See the discussion in this PR for more context : https://github.com/acasi-io/acasi/pull/3059
      return " ";
    }
    return value.toString().replace(".", ",");
  },
  onBeforeWrite: (event, buffer, caretPos, opts) => {
    if (event.type !== "keydown") {
      return;
    }

    const key = event.key;
    const isDecimalSeparator = key === "," || key === ".";
    const inputValue = buffer.join("").trim();
    if (isDecimalSeparator && inputValue === opts.radixPoint) {
      return {
        refreshFromBuffer: true,
        buffer: [opts.radixPoint, "0"],
      };
    }
  },
};

export default class extends Controller {
  static targets = [];
  static values = {
    customOptions: Object,
  };

  connect() {
    const config = { ...defaultConfig, ...this.customOptionsValue };

    Inputmask(config).mask(this.element);
  }
}
